export const TYPE_ROOM_MAP = {
  SGL: '1 местный',
  DBL: '2х местный',
  TRPI: '3х местный',
};